import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import Core from '@hcm4all/frontend-core'

const { Eye, EyeOff, Lock03 } = Core.UI.SVG.Icons

export default function PasswordInput (props) {
  const {
    label = I18n.t('activerecord.attributes.user.password'),
    id = 'user_password',
    name = 'user[password]',
    maxLength = 128,
    size = 128,
    required = false,
    onChange = undefined,
    className = null,
    autoComplete = 'current-password'
  } = props
  const [showPassword, setShowPassword] = React.useState(false)
  const requiredStateClass = required ? 'required' : 'optional'

  return (
    <div className={cn('form-group password', requiredStateClass, id)}>
      <label className={cn('control-label password', requiredStateClass)} htmlFor={id}>{label}</label>

      <div className='input-group'>
        <span className='input-group-addon has-svg d-flex justify-content-center align-items-center'>
          <span className='bg-transparent'>
            <Lock03 className='bg-transparent' />
          </span>
        </span>

        <input
          className={cn('password form-control rounded-0 border-start-0 border-end-0 flex-1', requiredStateClass, className)}
          aria-label={label}
          maxLength={maxLength}
          size={size}
          type={showPassword ? 'text' : 'password'}
          name={name}
          id={id}
          required={required}
          autoComplete={autoComplete}
          onChange={onChange}
        />

        <button
          aria-label={I18n.t('forms.toggle_password_visibility')}
          className='input-group-addon btn btn-default rounded-0 rounded-end-2 p-0 border-0'
          type='button'
          aria-pressed={showPassword}
          onClick={() => setShowPassword(prev => !prev)}
        >
          <span className='bg-transparent'>
            <Eye className={showPassword ? '' : 'd-none'} />
            <EyeOff className={showPassword ? 'd-none' : ''} />
          </span>
        </button>
      </div>
    </div>
  )
}

PasswordInput.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  maxLength: PropTypes.number,
  size: PropTypes.number,
  required: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  autoComplete: PropTypes.string
}
